import React, {Component} from 'react';
import {Grid, Icon} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import _ from 'lodash';

export class UploadView extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      filesSuccessful: this.props.filesSuccessful,
      isSelected: false,
      selectedFile: [],
    };
  }
  showSingleAttachments = true;

  renderErrors(messages) {
    return (
      <React.Fragment>
        {!!messages.length && (
          <Alert
            header="There was an error uploading the following attachment:"
            type="error"
          >
            {_.map(messages, (message, index) => (
              <p key={index}>
                <strong>{message.name}: </strong>
                {message.error}
              </p>
            ))}
          </Alert>
        )}
      </React.Fragment>
    );
  }

  renderFailed(file) {
    const hasErrors = file.error !== undefined;
    const errorMessages = _.map(hasErrors, (file) => ({
      name: file.fileName,
      error: file.error,
    }));
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <h4>Failed to upload:</h4>
          {this.renderErrors(errorMessages)}
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderFileInput(noFileDesc) {
    const {acceptedFileTypes, chooseMulti, attachmentType} = this.props;

    return (
      <input
        type="file"
        onChange={(e) => {
          e.preventDefault();
          this.setSelectedFile(e.target.files[0]);
          e.target.value = '';
        }}
        disabled={this.props.disabled}
        className="attachment-input-file"
        id={`attachmentUploadInput-${attachmentType}`}
        title="Upload document"
        multiple={chooseMulti}
        accept={acceptedFileTypes}
      />
    );
  }

  handleDescriptionChange = (index, res) => {
    const {name, value} = res;
    let filesSuccessful = this.state.filesSuccessful;
    filesSuccessful[index][name] = value;
    this.setState({
      filesSuccessful,
    });
  };

  setSelectedFile(file) {
    this.setState({
      ...this.state,
      selectedFile: file,
      isSelected: true,
    });
    this.props.handleChange(file);
  }

  formatUniqueID = (attachmentType) => {
    if (_.includes(attachmentType, '.attachmentIds')) {
      return _.capitalize(_.lowerCase(_.replace(attachmentType, '.attachmentIds', '')));
    } else {
      return attachmentType;
    }
  };

  render() {
    const {
      filesSuccessful,
      filesFailed,
      attachmentType,
      errorMessages,
      extended_attachment,
      acceptedFileTypes,
    } = this.props;
    const noFileDesc = _.get(extended_attachment, 'noFileDesc', false);
    const acceptedTypesDescriptor = acceptedFileTypes.join(', ');

    return (
      <div>
        {noFileDesc ? (
          <React.Fragment>
            <Grid
              className={`${!_.isEmpty(errorMessages) ? ' errorBorderLine' : ''}`}
              id={`${attachmentType}-section`}
            >
              {!_.isEmpty(errorMessages) && (
                <div className="errorMessages">{errorMessages}</div>
              )}
              <Grid.Row>
                <Grid.Column />
              </Grid.Row>
            </Grid>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Grid
              className={`${!_.isEmpty(errorMessages) ? ' errorBorderLine' : ''}`}
              id={`${attachmentType}-section`}
            >
              <Grid.Row>
                <Grid.Column width={6}>
                  <p>
                    <strong>Maximum file size:</strong>
                  </p>
                  {'1 MB'}
                </Grid.Column>
                <Grid.Column width={6}>
                  <strong>
                    <p>Accepted File Types:</p>
                  </strong>
                  {acceptedTypesDescriptor}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  {this.renderFileInput()}
                  <label
                    tabIndex={0}
                    htmlFor={`attachmentUploadInput-${attachmentType}`}
                    title="Attach a document"
                    className={`ui medium primary left floated button ${
                      this.props.disabled ? 'disabled' : ''
                    }`}
                  >
                    <Icon name="upload" />
                    Upload document
                  </label>
                </Grid.Column>
              </Grid.Row>
              {!!filesFailed.length && this.renderFailed(filesFailed)}
              {!_.isEmpty(errorMessages) && (
                <div className="errorMessages">{errorMessages}</div>
              )}
              {_.isEmpty(errorMessages) && this.state.isSelected && (
                <div>
                  <strong>Selected file: {this.state.selectedFile.name}</strong>
                </div>
              )}
            </Grid>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default UploadView;
